import ReactDOM from "react-dom";
import React from "react";
import queryString from "query-string";
import camelcaseKeys from "camelcase-keys";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { faUser, faUserNinja } from "@fortawesome/free-solid-svg-icons";

library.add(fab, faUser, faUserNinja);

import App from "components/App.jsx";

import "./styles.css";

const urlParams = camelcaseKeys(queryString.parse(document.location?.search));

const wrapper = document.getElementById("root");

const resize = () => {
  window.frameElement.style.height = `${document.body.scrollHeight}px`;
};

if (window.frameElement) {
  const resizeObserver = new ResizeObserver(() => {
    resize();
    setTimeout(resize, 1010); // This is a quick fix for retriggering resize after slide animation is done. 1000ms is a hard dependency anomation duration which is not ideal.
  });

  resizeObserver.observe(wrapper);
}

wrapper ? ReactDOM.render(<App {...urlParams} />, wrapper) : false;
